import {Holder, HolderWithMissingInfo, Product} from "../functions/types";
import {products} from "./products";

export const getHolders = (): Holder[] => {
    const productInfos: Product[] = products

    return holders.map(h => (
        {
            code: h.code,
            resistance: h.resistance,
            roofType: h.roofType,
            productInfo: productInfos.filter(info => info.productCode === h.code)[0],
            type: "Holder"
        }))
}

export const holders: HolderWithMissingInfo[] = [
    {
        code: '030029',
        resistance: 0.53,
        roofType: 'concreteTile',
    },
    {
        code: '030132',
        resistance: 0.53,
        roofType: 'concreteTile',
    },
    {
        code: '030218',
        resistance: 0.53,
        roofType: 'concreteTile',
    },
    {
        code: '030214',
        resistance: 0.53,
        roofType: 'concreteTile',
    },
    {
        code: '030045',
        resistance: 0.53,
        roofType: 'concreteTile',
    },
    {
        code: '030141',
        resistance: 0.53,
        roofType: 'concreteTile',
    },
    {
        code: '030231',
        resistance: 0.53,
        roofType: 'concreteTile',
    },
    {
        code: '030048',
        resistance: 0.53,
        roofType: 'concreteTile',
    },
    {
        code: '030142',
        resistance: 0.53,
        roofType: 'concreteTile',
    },
    {
        code: '030049',
        resistance: 0.53,
        roofType: 'concreteTile',
    },
    {
        code: '030143',
        resistance: 0.53,
        roofType: 'concreteTile',
    },
    {
        code: '030234',
        resistance: 0.53,
        roofType: 'concreteTile',
    },
    {
        code: '030051',
        resistance: 0.53,
        roofType: 'concreteTile',
    },
    {
        code: '030050',
        resistance: 0.53,
        roofType: 'concreteTile',
    },
    {
        code: '030085',
        resistance: 1.80,
        roofType: 'flatTile',
    },
    {
        code: '030162',
        resistance: 1.80,
        roofType: 'concreteTile',
    },
    {
        code: '030074',
        resistance: 1.59,
        roofType: 'concreteTile',
    },
    {
        code: '030155',
        resistance: 1.59,
        roofType: 'concreteTile',
    },
    {
        code: '030248',
        resistance: 1.59,
        roofType: 'concreteTile',
    },
    {
        code: '030081',
        resistance: 1.80,
        roofType: 'concreteTile',
    },
    {
        code: '030160',
        resistance: 1.80,
        roofType: 'concreteTile',
    },
    {
        code: '030084',
        resistance: 1.80,
        roofType: 'flatTile',
    },
    {
        code: '030161',
        resistance: 1.80,
        roofType: 'concreteTile',
    },
    {
        code: '030087',
        resistance: 1.80,
        roofType: 'concreteTile',
    },
    {
        code: '030164',
        resistance: 1.80,
        roofType: 'concreteTile',
    },
    {
        code: '030392',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030393',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030394',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030395',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030396',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030397',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030018',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030209',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030301',
        resistance: 1.9,
        roofType: 'concreteTile',
    },
    {
        code: '030307',
        resistance: 1.9,
        roofType: 'concreteTile',
    },
    {
        code: '030304',
        resistance: 1.90,
        roofType: 'concreteTile',
    },
    {
        code: '030310',
        resistance: 1.90,
        roofType: 'concreteTile',
    },
    {
        code: '030302',
        resistance: 1.90,
        roofType: 'concreteTile',
    },
    {
        code: '030308',
        resistance: 1.90,
        roofType: 'concreteTile',
    },
    {
        code: '030305',
        resistance: 1.90,
        roofType: 'concreteTile',
    },
    {
        code: '030311',
        resistance: 1.90,
        roofType: 'concreteTile',
    },
    {
        code: '030303',
        resistance: 1.90,
        roofType: 'concreteTile',
    },
    {
        code: '030309',
        resistance: 1.90,
        roofType: 'concreteTile',
    },
    {
        code: '030374',
        resistance: 1.90,
        roofType: 'concreteTile',
    },
    {
        code: '030375',
        resistance: 1.90,
        roofType: 'concreteTile',
    },
    {
        code: '030306',
        resistance: 1.90,
        roofType: 'concreteTile',
    },
    {
        code: '030312',
        resistance: 1.90,
        roofType: 'concreteTile',
    },
    {
        code: '030376',
        resistance: 1.90,
        roofType: 'concreteTile',
    },
    {
        code: '030377',
        resistance: 1.90,
        roofType: 'concreteTile',
    },
    {
        code: '030421',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030423',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030409',
        resistance: 3.75,
        roofType: 'concreteTile',
    },
    {
        code: '030411',
        resistance: 3.75,
        roofType: 'concreteTile',
    },
    {
        code: '030413',
        resistance: 3.75,
        roofType: 'concreteTile',
    },
    {
        code: '030415',
        resistance: 3.75,
        roofType: 'concreteTile',
    },
    {
        code: '030417',
        resistance: 3.75,
        roofType: 'concreteTile',
    },
    {
        code: '030419',
        resistance: 3.75,
        roofType: 'concreteTile',
    },
    {
        code: '030387',
        resistance: 2.2,
        roofType: 'concreteTile',
    },
    {
        code: '030388',
        resistance: 2.2,
        roofType: 'concreteTile',
    },
    {
        code: '030094',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030168',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030256',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030095',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030169',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030116',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030184',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030279',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030428',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030429',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030448',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030453',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030449',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030454',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030458',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030463',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030459',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030464',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030452',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030457',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030451',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030456',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030461',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030466',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030450',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030455',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030460',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030465',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030092',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030166',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030093',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030167',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030115',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030183',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030100',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030174',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030101',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030175',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030118',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030186',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030096',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030170',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030097',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030171',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030117',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030185',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030119',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030187',
        resistance: 1.000,
        roofType: 'concreteTile',
    },
    {
        code: '030089',
        resistance: 1.000,
        roofType: 'ondulatedPlate',
    },
    {
        code: '030165',
        resistance: 1.000,
        roofType: 'ondulatedPlate',
    },
    {
        code: '030253',
        resistance: 1.000,
        roofType: 'ondulatedPlate',
    },
    {
        code: '030090',
        resistance: 1.000,
        roofType: 'ondulatedPlate',
    },
    {
        code: '030321',
        resistance: 1.000,
        roofType: 'ondulatedPlate',
    },
    {
        code: '030091',
        resistance: 1.000,
        roofType: 'ondulatedPlate',
    },
    {
        code: '030389',
        resistance: 1.000,
        roofType: 'ondulatedPlate',
    },
    {
        code: '030370',
        resistance: 1.000,
        roofType: 'ondulatedPlate',
    },
    {
        code: '030372',
        resistance: 1.000,
        roofType: 'ondulatedPlate',
    },
    {
        code: '030371',
        resistance: 1.000,
        roofType: 'ondulatedPlate',
    },
    {
        code: '030373',
        resistance: 1.000,
        roofType: 'ondulatedPlate',
    },
    {
        code: '030430',
        resistance: 1.000,
        roofType: 'ondulatedPlate',
    },
    {
        code: '030431',
        resistance: 1.000,
        roofType: 'ondulatedPlate',
    },
    {
        code: '030432',
        resistance: 1.000,
        roofType: 'ondulatedPlate',
    },
    {
        code: '030433',
        resistance: 1.000,
        roofType: 'ondulatedPlate',
    },
    {
        code: '040248',
        resistance: 1.60,
        roofType: 'metalRoof',
    },
    {
        code: '040249',
        resistance: 1.60,
        roofType: 'metalRoof',
    },
    {
        code: '040250',
        resistance: 1.60,
        roofType: 'metalRoof',
    },
    {
        code: '040251',
        resistance: 1.60,
        roofType: 'metalRoof',
    },
    {
        code: '040252',
        resistance: 1.60,
        roofType: 'metalRoof',
    },
    {
        code: '040253',
        resistance: 1.60,
        roofType: 'metalRoof',
    },
    {
        code: '030484',
        resistance: 1.000,
        roofType: 'metalRoof',
    },
    {
        code: '030485',
        resistance: 1.000,
        roofType: 'metalRoof',
    },
    {
        code: '030486',
        resistance: 1.000,
        roofType: 'metalRoof',
    },
    {
        code: '030487',
        resistance: 1.000,
        roofType: 'metalRoof',
    },
    {
        code: '030488',
        resistance: 1.000,
        roofType: 'metalRoof',
    },
    {
        code: '030489',
        resistance: 1.000,
        roofType: 'metalRoof',
    },
    {
        code: '030473',
        resistance: 1.000,
        roofType: 'metalRoof',
    },
    {
        code: '030445',
        resistance: 1.000,
        roofType: 'metalRoof',
    },
    {
        code: '030441',
        resistance: 1.000,
        roofType: 'metalRoof',
    },
    {
        code: '030447',
        resistance: 1.000,
        roofType: 'metalRoof',
    },
    {
        code: '030446',
        resistance: 1.000,
        roofType: 'metalRoof',
    },
    {
        code: '030493',
        resistance: 1.000,
        roofType: 'metalRoof',
    },
    {
        code: '030444',
        resistance: 1.000,
        roofType: 'metalRoof',
    },
    {
        code: '030440',
        resistance: 1.000,
        roofType: 'metalRoof',
    },
    {
        code: '030490',
        resistance: 1.000,
        roofType: 'metalRoof',
    },
    {
        code: '030491',
        resistance: 1.000,
        roofType: 'metalRoof',
    },
    {
        code: '030494',
        resistance: 1.000,
        roofType: 'metalRoof',
    },
    {
        code: '030492',
        resistance: 1.000,
        roofType: 'metalRoof',
    },
    {
        code: '030495',
        resistance: 1.000,
        roofType: 'metalRoof',
    },
    {
        code: '030252',
        resistance: 1.000,
        roofType: 'standingSeam',
    },
    {
        code: '030286',
        resistance: 1.000,
        roofType: 'standingSeam',
    },
    {
        code: '030285',
        resistance: 1.000,
        roofType: 'standingSeam',
    },
    {
        code: '030251',
        resistance: 1.000,
        roofType: 'standingSeam',
    },
    {
        code: '030474',
        resistance: 1.000,
        roofType: 'standingSeam',
    },
    {
        code: '030476',
        resistance: 1.000,
        roofType: 'standingSeam',
    },
    {
        code: '030475',
        resistance: 1.000,
        roofType: 'standingSeam',
    },
    {
        code: '030477',
        resistance: 1.000,
        roofType: 'standingSeam',
    },
    {
        code: '030478',
        resistance: 1.000,
        roofType: 'standingSeam',
    },
    {
        code: '030471',
        resistance: 1.000,
        roofType: 'standingSeam',
    },
    {
        code: '030472',
        resistance: 1.000,
        roofType: 'standingSeam',
    },
    {
        code: '030009',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030204',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030033',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030134',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030035',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030221',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030034',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030135',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030241',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030073',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030154',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030247',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030314',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030317',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030315',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030318',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030316',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030319',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030422',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030424',
        resistance: 1.000,
        roofType: 'flatTile',
    },
    {
        code: '030357',
        resistance: 2.2,
        roofType: 'flatTile',
    },
    {
        code: '030360',
        resistance: 2.2,
        roofType: 'flatTile',
    },
    {
        code: '030410',
        resistance: 3.75,
        roofType: 'flatTile',
    },
    {
        code: '030412',
        resistance: 3.75,
        roofType: 'flatTile',
    },
    {
        code: '030414',
        resistance: 3.75,
        roofType: 'flatTile',
    },
    {
        code: '030416',
        resistance: 3.75,
        roofType: 'flatTile',
    },
    {
        code: '030418',
        resistance: 3.75,
        roofType: 'flatTile',
    },
    {
        code: '030420',
        resistance: 3.75,
        roofType: 'flatTile',
    },
    {
        code: '030401',
        resistance: 2.00,
        roofType: 'flatTile'
    }
]